import { render, staticRenderFns } from "./EhStudentApplicationForm.vue?vue&type=template&id=24c67d70"
import script from "./EhStudentApplicationForm.vue?vue&type=script&lang=js"
export * from "./EhStudentApplicationForm.vue?vue&type=script&lang=js"
import style0 from "./EhStudentApplicationForm.vue?vue&type=style&index=0&id=24c67d70&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports